import type { PrivateConfig, PublicConfig } from "@mimsights-shared/types";

export const PUBLIC_CONFIG_DEFAULTS: Omit<Required<PublicConfig>, "id"> = {
  static: {
    baseName: "Mimsights",
    mimboxName: "Mimbox",
    mimboxShortName: "Mimbox",
    siteName: "Mimsights",
  },
  features: {},
};

export const PRIVATE_CONFIG_DEFAULTS: Omit<Required<PrivateConfig>, "id"> = {
  features: {
    allowAdminPrivileges: false,
    allowNotifyErrors: false,
    allowNotifyViaSMS: false,
    allowServiceAndRepairDownload: false,
    notifyMonthlyMaintenaceMailTemplateId: null,
    notifyWeeklyMaintenaceMailTemplateId: null,
  },
  static: {},
};

type Config = Pick<PublicConfig | PrivateConfig, "static" | "features">;

/** True if any `static` or `features` value of `config` is set to something other than the default */
export function isConfigCustomized(config: Config, defaults: Config): boolean {
  return (["static", "features"] as const).some((group) =>
    Object.entries(config[group] || {}).some(([key, value]) => {
      const defaultValue = (defaults[group] as Record<string, unknown> | undefined)?.[key];
      return value != null && value !== "" && value !== defaultValue;
    }),
  );
}
